<!-- Page Content -->
<div id="page-content">
  <!-- Slider -->
  <div id="homepage-carousel">

    <div class="container">
      <div class="homepage-carousel-wrapper">
        <div class="row">
          <div class="col-md-6 col-sm-7">

            <ngb-carousel>
              <ng-template ngbSlide *ngFor="let slide of slidesData">
                <div class="picsum-img-wrapper">
                  <img src="{{slide.image}}" alt="Random first slide">
                </div>
              </ng-template>
            </ngb-carousel>

          </div><!-- /.col-md-6 -->
          <div class="col-md-6 col-sm-5">
            <div class="slider-content">
              <div class="row">
                <div class="col-md-12">
                  <div class="logo wow fadeInRight animated">
                    <h3 class="home-header">Dedicated to producing a high-calibre professional, responsible citizen, uncompromising advocate of social justice and humane & nature-friendly leader</h3>
                    <br>
                  </div>
                  <div class="logo wow fadeInUp animated">
                    <div class="row">
                      <div class="col-md-3 col-6">
                        <div class="slider-img-tab">
                          <a href="https://www.hsscu.ruh.ac.lk/login/index.php" target="_blank">
                            <img class="icon-img" src="assets/img/hss_lms.png" alt="Hss LMS">
                          </a>
                        </div>
                      </div><!-- /.col-md-3 -->

                      <div class="col-md-3 col-6">
                        <div class="slider-img-tab">
                          <a href="https://admin.fohss.lk" target="_blank">
                            <img class="icon-img" src="assets/img/hss_mis.png" alt="MIS">
                          </a>
                        </div>
                      </div><!-- /.col-md-3 -->

                      <div class="col-md-3 col-6">
                        <div class="slider-img-tab">
                          <a href="https://cloud.hss.ruh.ac.lk" target="_blank">
                            <img class="icon-img" src="assets/img/hss_cloud.png" alt="Lecture hall allocation">
                          </a>
                        </div>
                      </div><!-- /.col-md-3 -->

                      <div class="col-md-3 col-6">
                        <div class="slider-img-tab">
                          <a routerLink="/lhms/calendar">
                            <img class="icon-img" src="assets/img/lecture_hall_allocate.png" alt="Meeting Calender">
                          </a>
                        </div>
                      </div><!-- /.col-md-3 -->
                    </div>
                    </div>

                </div><!-- /.col-md-12 -->

              </div><!-- /.row -->


            </div><!-- /.slider-content -->
          </div><!-- /.col-md-6 -->
        </div><!-- /.row -->
        <div class="background"></div>
      </div><!-- /.slider-wrapper -->
      <div class="slider-inner"></div>
    </div><!-- /.container -->
  </div>
  <!-- end Slider -->

  <div id="container">
    <div id="content">
      <div style="width: 80%; margin-left: auto; margin-right: auto;">
      </div>
    </div>
  </div>

  <!-- our parallax stuff -->
  <div appParallax [ratio]="-0.2" id="square"></div>

  <!-- News, Events, About -->

  <div class="block">
    <div class="container">

      <div class="row">

        <div class="col-md-8">
          <div class="logo wow bounceInLeft animated">
          <div id="page-main">
            <section class="events images" id="events">
              <header><h3>Events</h3></header>
              <div *ngIf="eventsData.length == 0">
                <h3>No upcoming Events...</h3>
              </div>

              <!--CSS Loader-->
              <section *ngIf="eventLoader">
              <div class="ph-item ph-item-new ph-margin" *ngFor="let x of newsRepat">
                <div class="ph-col-4 ph-margin">
                  <div class="ph-picture"></div>
                </div>
                <div>
                  <div class="ph-row">
                    <div class="ph-col-12"></div>
                    <div class="ph-col-10"></div>
                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-6"></div>
                    <div class="ph-col-6 empty"></div>
                    <div class="ph-col-12"></div>
                    <div class="ph-col-12"></div>
                    <div class="ph-col-10"></div>
                    <div class="ph-col-2 empty"></div>
                    <div class="ph-col-2"></div>
                    <div class="ph-col-10 empty"></div>
                  </div>
                </div>
              </div>
              </section>
              <!--CSS Loader-->

              <div *ngIf="eventsData.length != 0">
                <div class="section-content" *ngFor="let event of eventsData.slice(0, 7) let i=index">
                  <article class="event">
                    <div class="event-thumbnail">
                      <figure class="event-image">
                        <div class="image-wrapper">
                          <a routerLink="/info/{{event.id}}" >
                            <img src="{{event.images}}">
                          </a>
                        </div>
                      </figure>
                      <figure class="date {{eventColor+(i+1)}}">
                        <div class="month">{{ event.commence_date | date:'MMMM' }}</div>
                        <div class="day">{{ event.commence_date | date:'d' }}</div>
                      </figure>
                    </div>
                    <aside>
                      <header>
                        <a routerLink="/info/{{event.id}}">{{event.title | slice:0:100}}...</a>
                      </header>

                      <div class="additional-info"><span class="fa fa-calendar"></span>
                        <span> {{ event.commence_date | date:'MMMM d, y' }}</span>
                        <span *ngIf="event.complete_date != event.commence_date">
                        to {{ event.complete_date | date:'MMMM d, y' }}
                      </span>
                      </div>

                      <div class="description short-desc">
                        <div [innerHTML]="event.short_desc"></div>
                          <a routerLink="/info/{{event.id}}">
                            more...
                          </a>
                      </div>
                    </aside>
                  </article><!-- /.info -->
                </div>
              </div>
            </section>
            <a routerLink="/allinfo" class="read-more stick-to-bottom">All Events</a>
          </div>

          </div>
        </div>


        <div class="col-md-4 col-sm-12">
          <strong>Important Links</strong>
          <br>

          <span>
            <h5>
              <a href="https://learn.zoom.us/" target="_blank" class="badge badge-warning">Zoom Link</a>&nbsp;
              <a href="https://eugc.ac.lk/rag/" target="_blank" class="badge badge-dark">UGC Ragging Complaints</a>&nbsp;
              <a href="https://www.lib.ruh.ac.lk/web/index.php" target="_blank" class="badge badge-dark">Main Library</a>&nbsp;
              <a href="assets/docs/academic_calender.pdf" target="_blank" class="badge badge-success">Academic Calendar</a>&nbsp;
              <a href="https://admin.fohss.lk/" target="_blank" class="badge badge-primary">Member Login</a>&nbsp;
              <a href="https://oldlms.fohss.lk" target="_blank" class="badge badge-success">Old LMS</a>&nbsp;
              <a href="https://login.microsoftonline.com" target="_blank" class="badge badge-danger">Check Email</a>
            </h5>
          </span>
          <hr>
          <span>
            <a routerLink="international-students">
              <img src="assets/img/international_students.jpg" alt="Apply International Students for Faculty of Humanities & social sciences" class="add-margin conf_image">
            </a>
          </span>
          <br>

          <div *ngIf="confData.length == 0">
            <h3>No Conferences...</h3>
          </div>
          <div *ngIf="confData.length != 0">
            <section id="rasas" *ngFor="let conf of confData.slice(0,4) let i=index">
              <header>
                <h5>
                  <a routerLink="/info/{{conf.id}}">{{conf.title}}</a>
                </h5>
              </header>
              <div class="section-content">
                <a routerLink="/info/{{conf.id}}">
                      <img src="{{conf.images}}" alt="" class="add-margin conf_image">
                </a>
              </div><!-- /.section-content -->
            </section><!-- /.about -->
          </div>

          <!--Newsletters-->
          <h5>Newsletters</h5>
          <div *ngIf="newsLetterData.length != 0">

            <div class="newsletter-grid">
              <section id="newsletters"
                       *ngFor="let newslet of newsLetterData.slice(0,30); let i=index">

                <div class="section-content">
                  <a [href]="newslet?.files" target="_blank">
                    <img [src]="newslet?.images"
                         alt=""
                         class="add-margin newsletter_image">
                  </a>
                </div>

              </section>
            </div>

            <div>
              <a routerLink="/otherinfo/9" class="read-more">
                All Newsletters
              </a>
            </div>

          </div>

        </div><!-- /.col-md-4 -->

      </div><!-- /.row -->

      <div class="row">
        <div class="col-md-8">
          <div class="block news-back">
            <div class="graph wow fadeInLeft animated">
              <section class="events grid container" id="events">
                <header><h3>Latest News</h3></header>
                <div class="row">

                  <div class="col-md-6" *ngFor="let news of newsData.slice(0,6) let i=index">
                    <article class="event">
                      <figure class="images">
                        <a routerLink="/info/{{news.id}}">
                          <img src="{{news.images}}">
                        </a>
                      </figure>
                      <aside>
                        <div class="description">
                          <a routerLink="/info/{{news.id}}">
                            <div>{{news.title}}</div>
                            <span class="course-date"><i class="fa fa-calendar-o"></i>{{ news.commence_date | date:'MMMM d, y' }}</span>
                          </a>
                        </div>
                      </aside>
                    </article><!-- /article -->
                  </div><!-- /.col-md-6 -->

                  <div class="col-md-8">
                    <a routerLink="/allnews" class="read-more stick-to-bottom">All News</a>
                  </div>
                </div><!-- /.row -->
              </section>
            </div>
          </div>
        </div>
      </div>

    </div><!-- /.container -->
  </div>
  <!-- end News, Events, About -->



  <div class="block notices-back">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
            <section class="blog-listing">
                <header><h3>Student Notices</h3></header>
                <div class="row" *ngIf="noticeData.length != 0">
                    <div class="col-md-4 col-sm-4" *ngFor="let notice of noticeData.slice(0,6) let i=index">
                        <article class="blog-listing-post" >
                            <aside>
                                <header>
                                  <i class="fa fa-file-o"></i>{{ notice.commence_date | date:'MMMM d, y' }}
                                </header>
                                <div class="description">
                                  <a routerLink="/info/{{notice.id}}">
                                    {{notice.title}}
                                  </a>
                                </div>
                            </aside>
                        </article><!-- /article -->
                    </div><!-- /.col-md-6 -->
                  <div class="col-md-8"><a routerLink="/otherinfo/3" class="read-more stick-to-bottom">All Notices</a></div>
                </div><!-- /.row -->

            </section><!-- /.blog-listing -->
        </div>
      </div>
    </div>
  </div>

  <div class="block vacancies-back" *ngIf="vacancyData.length != 0">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
            <section class="blog-listing" id="blog-listing">
                <header><h3>Vacancies</h3></header>
                <div class="row">
                    <div class="col-md-3 col-sm-4" *ngFor="let vacancy of vacancyData.slice(0,5) let i=index">
                        <article class="blog-listing-post" >
                            <aside>
                                <header>
                                  <i class="fa fa-calendar-o"></i>{{ vacancy.commence_date | date:'MMMM d, y' }}
                                </header>
                                <div class="description">
                                  <a routerLink="/info/{{vacancy.id}}">
                                    {{vacancy.title}}
                                  </a>
                                </div>
                                <!-- <a href="blog-detail.html" class="read-more stick-to-bottom">Read More</a> -->
                            </aside>
                        </article>
                    </div>
                    <div class="col-md-12"><a routerLink="/otherinfo/4" class="read-more stick-to-bottom">All Vacancies</a></div>
                </div>

            </section>
        </div>
      </div>
    </div>
  </div>

  <div class="block" *ngIf="booksData.length != 0">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div id="page-main">
            <section class="course-listing" id="courses">
              <header><h3>Publications</h3></header>
                <div>

                    <ngb-carousel>
                      <ng-template ngbSlide>
                        <div class="row">
                          <div class="col-md-3 col-sm-3" *ngFor="let book of booksData.slice(0,4) let i=index">
                            <article class="course-thumbnail">
                              <figure class="image">
                                <div class="image-wrapper">
                                  <a routerLink="/info/{{book.id}}">
                                    <img src="{{book.images}}">
                                  </a>
                                </div>
                              </figure>
                              <div class="description">
                                <a routerLink="/info/{{book.id}}">
                                  <h4>{{book.title | slice:0:60}}</h4>
                                </a>
                                <hr>
                                <div class="course-meta">
                                  <span class="course-date"><i class="fa fa-calendar-o"></i>{{ book.commence_date | date:'MMMM d, y' }}</span>
                                </div>
                              </div>
                            </article><!-- /.featured-course -->
                          </div><!-- /.col-md-3 -->
                        </div>
                      </ng-template>



                    </ngb-carousel>
<!--                  </div>&lt;!&ndash; /.row &ndash;&gt;-->
                </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Testimonial -->
  <section id="testimonials">
    <div class="block">
      <div class="container">
        <header><h3>Testimonials</h3></header>
        <ngb-carousel>
          <ng-template ngbSlide *ngFor="let testimonial of testimonialData.slice(0,10) let i=index">
            <div class="col-md-12 col-sm-12">
              <div class="author">
                <blockquote>
                  <figure class="author-picture"><img src="{{testimonial.images}}" alt=""></figure>
                  <article class="paragraph-wrapper">
                    <div class="inner">
                      <header>
                        <div [innerHTML]="testimonial.long_desc"></div>
                      </header>
                      <footer class="testimonial-footer">{{testimonial.title}}</footer>
                    </div>
                  </article>
                </blockquote>
              </div><!-- /.author -->
            </div>
          </ng-template>
        </ngb-carousel>
      </div>
    </div>
  </section>

  <!-- Academic Life, Campus Life, Newsletter -->
  <div class="block sec-faculty">
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-sm-4">
          <section id="academic-life">
            <header>
              <h2>Faculties</h2>
            </header>
            <div class="section-content">
              <ul class="list-links">
                <li><a href="https://www.agri.ruh.ac.lk/" target="_blank">Agriculture</a></li>
                <li><a href="http://www.ahs.ruh.ac.lk/" target="_blank">Allied Health Sciences</a></li>
                <li><a href="http://www.eng.ruh.ac.lk/" target="_blank">Engineering</a></li>
                <li><a href="http://www.fmst.ruh.ac.lk/" target="_blank">Fisheries and Marine Sciences & Technology</a></li>
                <li><a href="http://www.fgs.ruh.ac.lk/" target="_blank">Graduate Studies</a></li>
                <li><a href="http://www.mgt.ruh.ac.lk/" target="_blank">Management and Finance</a></li>
                <li><a href="http://www.medi.ruh.ac.lk/" target="_blank">Faculty of Medicine</a></li>
                <li><a href="https://alpha.ruh.ac.lk/FacultyofScience/" target="_blank">Science</a></li>
                <li><a href="http://www.tec.ruh.ac.lk/" target="_blank">Technology</a></li>
              </ul>
            </div><!-- /.section-content -->
          </section><!-- /.academic-life -->
        </div><!-- /.col-md-4 -->

        <div class="col-md-4 col-sm-4">
          <section id="campus-life">
            <header>
              <h2>Research Journals</h2>
            </header>
            <div class="section-content">
              <ul class="list-links">
                <li><a href="https://www.hss.ruh.ac.lk/JSSHR/" target="_blank">E-JOURNAL of Social Sciences and Humanities</a></li>
                <li><a href="https://www.hss.ruh.ac.lk/JoHSS/" target="_blank">Journal of the Faculty of Humanities and Social Sciences</a></li>
                <li><a href="https://jur.sljol.info" target="_blank">Journal of the University of Ruhuna</a></li>
                <li><a href="http://www.mgt.ruh.ac.lk/rjmf/" target="_blank">Ruhuna Journal of Management and Finance (RJMF)</a></li>
                <li><a href="https://rjs.ruh.ac.lk/index.php/rjs/index" target="_blank">Ruhuna Journal of Science (RJS)</a></li>
                <li><a href="https://www.agri.ruh.ac.lk/tare/index.htm" target="_blank">Tropical Agricultural Research and Extension (TARE)</a></li>
                <li><a href="https://www.lib.ruh.ac.lk/rohana/" target="_blank">ROHANA Journal</a></li>
              </ul>
            </div><!-- /.section-content -->
          </section><!-- /.campus-life -->
        </div><!-- /.col-md-4 -->

        <div class="col-md-4 col-sm-4">
          <section id="newsletter">
            <header>
              <h2>Contact & Feedback</h2>
              <div class="section-content">
                <div class="newsletter">
                  <div class="input-group">
<!--                    <input type="text" class="form-control" placeholder="Your e-mail">-->
                    <span class="input-group-btn">
                      <button type="submit" class="btn" routerLink="/contact">
                        Send us your feedback
                        <i class="fa fa-angle-right"></i>
                      </button>
                    </span>
                  </div><!-- /input-group -->
                </div><!-- /.newsletter -->
                <p class="opacity-50">The Faculty of Humanities and Social Sciences value your feedback.
                </p>
              </div><!-- /.section-content -->
            </header>
          </section><!-- /.newsletter -->
        </div><!-- /.col-md-4 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>
  <!-- end Academic Life, Campus Life, Newsletter -->

  <!-- Our Professors, Gallery -->
  <div class="block">
    <div class="container">
      <div class="row">
<!--        <div class="col-md-4 col-sm-4">-->
<!--          <section id="our-professors">-->
<!--            <header>-->
<!--              <h2>Our Professors</h2>-->
<!--            </header>-->
<!--            <div class="section-content">-->
<!--              <div class="professors">-->
<!--                <article class="professor-thumbnail">-->
<!--                  <figure class="professor-image"><a href="member-detail.html"><img src="assets/img/professor.jpg" alt=""></a></figure>-->
<!--                  <aside>-->
<!--                    <header>-->
<!--                      <a href="member-detail.html">Prof. Mathew Davis</a>-->
<!--                      <div class="divider"></div>-->
<!--                      <figure class="professor-description">Applied Science and Engineering</figure>-->
<!--                    </header>-->
<!--                    <a href="member-detail.html" class="show-profile">Show Profile</a>-->
<!--                  </aside>-->
<!--                </article>&lt;!&ndash; /.professor-thumbnail &ndash;&gt;-->
<!--                <article class="professor-thumbnail">-->
<!--                  <figure class="professor-image"><a href="member-detail.html"><img src="assets/img/professor-02.jpg" alt=""></a></figure>-->
<!--                  <aside>-->
<!--                    <header>-->
<!--                      <a href="member-detail.html">Prof. Jane Stairway</a>-->
<!--                      <div class="divider"></div>-->
<!--                      <figure class="professor-description">Applied Science and Engineering</figure>-->
<!--                    </header>-->
<!--                    <a href="member-detail.html" class="show-profile">Show Profile</a>-->
<!--                  </aside>-->
<!--                </article>&lt;!&ndash; /.professor-thumbnail &ndash;&gt;-->
<!--                <a href="" class="read-more stick-to-bottom">All Professors</a>-->
<!--              </div>&lt;!&ndash; /.professors &ndash;&gt;-->
<!--            </div>&lt;!&ndash; /.section-content &ndash;&gt;-->
<!--          </section>&lt;!&ndash; /.our-professors &ndash;&gt;-->
<!--        </div>&lt;!&ndash; /.col-md-4 &ndash;&gt;-->

        <div class="col-md-12 col-sm-12">
          <div class="graph wow bounceInUp animated">
          <section id="gallery">
            <header>
<!--              <h2>Gallery</h2>-->
            </header>
            <div class="section-content">
              <ul class="gallery-list">
                <li><a href="assets/img/1.jpg" class="image-popup"><img src="assets/img/1.jpg" alt=""></a></li>
                <li><a href="assets/img/2.jpg" class="image-popup"><img src="assets/img/2.jpg" alt=""></a></li>
                <li><a href="assets/img/3.jpg" class="image-popup"><img src="assets/img/3.jpg" alt=""></a></li>
                <li><a href="assets/img/4.jpg" clsass="image-popup"><img src="assets/img/4.jpg" alt=""></a></li>
                <li><a href="assets/img/5.jpg" class="image-popup"><img src="assets/img/5.jpg" alt=""></a></li>
                <li><a href="assets/img/6.jpg" class="image-popup"><img src="assets/img/6.jpg" alt=""></a></li>
                <li><a href="assets/img/6.jpg" class="image-popup"><img src="assets/img/7.jpg" alt=""></a></li>
                <li><a href="assets/img/8.jpg" class="image-popup"><img src="assets/img/8.jpg" alt=""></a></li>
                <li><a href="assets/img/9.jpg" class="image-popup"><img src="assets/img/9.jpg" alt=""></a></li>
                <li><a href="assets/img/10.jpg" class="image-popup"><img src="assets/img/10.jpg" alt=""></a></li>
              </ul>
<!--              <a href="" class="read-more">Go to Gallery</a>-->
            </div><!-- /.section-content -->
          </section><!-- /.gallery -->
        </div><!-- /.col-md-4 -->
        </div>
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>
  <!-- end Our Professors, Gallery -->

  <!-- Partners, Make a Donation -->
  <div class="block">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <section id="partners">
            <header>
              <h3>Conferences - University of Ruhuna</h3>
            </header>
            <div class="section-content">
              <div class="logos">
                <div class="logo conf-logo"><a href="https://hss.ruh.ac.lk/rasas/RASAS2021" target="_blank"><img src="assets/img/rasas.jpg" alt=""></a></div>
                <div class="logo conf-logo"><a href="https://hss.ruh.ac.lk/ruichss/ruichss2021/" target="_blank"><img src="assets/img/ruichss.jpg" alt=""></a></div>
                <div class="logo conf-logo"><a href="http://www.isae.agri.ruh.ac.lk" target="_blank"><img src="assets/img/isae.jpg" alt=""></a></div>
                <div class="logo conf-logo"><a href="https://www.agri.ruh.ac.lk/Symposium/ismfm&ap" target="_blank"><img src="assets/img/ismfm_mp.jpg" alt=""></a></div>
                <div class="logo conf-logo"><a href="http://www.ahs.ruh.ac.lk/ahs/RUFARS" target="_blank"><img src="assets/img/fars.jpg" alt=""></a></div>
                <div class="logo conf-logo"><a href="http://www.eng.ruh.ac.lk/ARS2020" target="_blank"><img src="assets/img/ars.jpg" alt=""></a></div>
                <div class="logo conf-logo"><a href="http://mgt.ruh.ac.lk/sajbi" target="_blank"><img src="assets/img/sajbi.jpg" alt=""></a></div>
                <div class="logo conf-logo"><a href="http://mgt.ruh.ac.lk/icme2020" target="_blank"><img src="assets/img/icme.jpg" alt=""></a></div>
                <div class="logo conf-logo"><a href="https://www.sci.ruh.ac.lk/conference/ristcon2021" target="_blank"><img src="assets/img/ristcon.jpg" alt=""></a></div>
              </div>
            </div>
          </section>
        </div><!-- /.col-md-9 -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </div>
  <!-- end Partners, Make a Donation -->
</div>
<!-- end Page Content -->
